import { z } from "zod";

import { zSchema as zOptionsSchema } from "./options";
import { getNumberOfSkippedItems } from "./utils";

const zSchema = z
  .object({
    options: z.object({
      number: zOptionsSchema.removeDefault().shape.number.removeDefault(),
      size: zOptionsSchema.removeDefault().shape.size.removeDefault(),
    }),
    totalItems: z.number().int().nonnegative(),
  })
  .transform(({ options, totalItems }) => {
    const value = {
      ...options,
      totalItems,
      get totalPages(): number {
        return Math.ceil(this.totalItems / this.size);
      },
      get itemsSkipped(): number {
        return getNumberOfSkippedItems({
          number: this.number,
          size: this.size,
        });
      },
      get hasPrevious(): boolean {
        const { number } = this;
        return number > 1 && number <= this.totalPages;
      },
      get hasNext(): boolean {
        const { number } = this;
        return number < this.totalPages;
      },
    };

    return value;
  });
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
